import { GAME_ACTION } from '../../constants/actions'

const changeGameState = (property, value) => ({
  type: GAME_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const resetGameState = () => ({
  type: GAME_ACTION.RESET_STATE
})

const playGame = (id, amount) => ({
  type: GAME_ACTION.PLAY_GAME,
  payload: {
    id,
    amount
  }
})

export { changeGameState, resetGameState, playGame }
